/**
 * @file typedNote.ts
 * @brief "Your note": the label on a Notes v2 point the owner typed.
 *
 * @details
 * DES 10-10-2026: a point the owner typed in the notepad during the meeting
 * (`typed: true` on the lead bullet) leads its topic with a small "Your note"
 * label and the pen before the text, in the secondary colour. Same words as
 * the app (FRONTEND notesDoc.ts TYPED_NOTE_LABEL) and the PDF. No imports, so
 * `node --test` runs it as is.
 *
 * @author DES
 * @date 10-10-2026
 */

export const TYPED_NOTE_LABEL = "Your note";

/** Lead bullets the owner typed (the ones that get the "Your note" label). */
export function typedLeadCount(
  doc: { sections?: { bullets?: { typed?: boolean }[] }[] } | null | undefined,
): number {
  return (doc?.sections ?? []).reduce(
    (n, s) => n + (s.bullets ?? []).filter((b) => b?.typed === true).length,
    0,
  );
}
